<template>
<svg xmlns="http://www.w3.org/2000/svg" style="background-color:#1877f2" viewBox="0 0 24 24"><path fill="#fff" d="M9.2 21.5h4v-8.01h3.6l.4-3.98h-4V7.5a1 1 0 0 1 1-1h3v-4h-3a5 5 0 0 0-5 5v2.01h-2l-.4 3.98h2.4z"/></svg>
</template>
